import { Directive, Input, TemplateRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Directive({
    selector: '[euiTemplate]',
})
export class EuiTemplateDirective {
    @Input() type: string;
    @Input('euiTemplate') name: string;

    constructor(public template: TemplateRef<any>) { }

    getType(): string {
        return this.name;
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [EuiTemplateDirective],
    declarations: [EuiTemplateDirective],
})
export class EuiTemplateDirectiveModule { }
